var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7224_49729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6673C4.31792 14.6673 1.33325 11.6827 1.33325 8.00065C1.33325 4.31865 4.31792 1.33398 7.99992 1.33398C11.6819 1.33398 14.6666 4.31865 14.6666 8.00065C14.6666 11.6827 11.6819 14.6673 7.99992 14.6673ZM7.99992 13.334C9.41441 13.334 10.771 12.7721 11.7712 11.7719C12.7713 10.7717 13.3333 9.41514 13.3333 8.00065C13.3333 6.58616 12.7713 5.22961 11.7712 4.22941C10.771 3.22922 9.41441 2.66732 7.99992 2.66732C6.58543 2.66732 5.22888 3.22922 4.22868 4.22941C3.22849 5.22961 2.66659 6.58616 2.66659 8.00065C2.66659 9.41514 3.22849 10.7717 4.22868 11.7719C5.22888 12.7721 6.58543 13.334 7.99992 13.334ZM7.99992 7.05798L9.88525 5.17198L10.8286 6.11532L8.94258 8.00065L10.8286 9.88598L9.88525 10.8293L7.99992 8.94332L6.11459 10.8293L5.17125 9.88598L7.05725 8.00065L5.17125 6.11532L6.11459 5.17198L7.99992 7.05798Z",
    fill: "#9E7201"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7224_49729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularClose);
export default __webpack_public_path__ + "static/media/circular-close.57e6fc309f1e69e0a3401b6fd66813a9.svg";
export { ForwardRef as ReactComponent };